/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import moment from 'moment';
import * as actionTypes from './actionTypes';

const initialState = {
  performDisputeResolutionObj: {},
  planType: [],
  selectedPlanType: '',
  rebateProgram: [],
  errorMsgDrug: [],
  rebateProgramName: {},
  quarterFrom: '',
  selectedReport: 'Detail',
  subDetail: [],
  subSummary: [],
  subInfo: [],
  displayObj: {
    rebateProgramName: {},
    quarterFrom: '',
    subDetail: [],
    subSummary: [],
  },
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CURRENT_DISPLAY_OBJ_DRUG:
      return { ...state, performResolutionObj: action.screenData };
    case actionTypes.GET_ERROR_MSG_DRUG:
      return { ...state, errorMsgDrug: action.payload };
    case actionTypes.GET_PLAN_TYPE_DATA_DRUG:
      return { ...state, planType: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_DRUG:
      return { ...state, rebateProgram: action.payload };
    case actionTypes.GET_FROM_DRUG:
      return { ...state, quarterFrom: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_NAME_DRUG:
      return { ...state, rebateProgramName: action.payload };

    case actionTypes.SET_SELECTED_REPORT_DRUG:
      return { ...state, ...action.payload };

    case actionTypes.SET_SUBSTANCE_DRUG_DETAIL:
      let displayObj = {
        ...state.displayObj,
        subDetail: action.payload,
      };
      return { ...state, subDetail: action.payload, displayObj };

    case actionTypes.SET_SUBSTANCE_DRUG_SUMMARY:
      let displayObj1 = {
        ...state.displayObj,
        subSummary: action.payload,
      };
      return { ...state, subSummary: action.payload, displayObj: displayObj1 };
    case actionTypes.SET_DISPLAY_OBJ_DRUG:
      let tempObj = JSON.parse(JSON.stringify(action.payload));
      return { ...state, displayObj: tempObj };
    case actionTypes.SET_SUBSTANCE_DRUG_INFO:
      return { ...state, subInfo: action.payload };
    case actionTypes.SET_REFRESH_DATA_DRUG:
      return {
        ...state,
        performDisputeResolutionObj: {},
        planType: [],
        selectedPlanType: '',
        rebateProgram: [],
        errorMsgDrug: [],
        rebateProgramName: {},
        quarterFrom: '',
        selectedReport: 'Detail',
        subDetail: [],
        subSummary: [],
        subInfo: [],
      };
    case actionTypes.SET_REFRESH_DATA_DRUG_DISPLAY:
      return {
        ...state,
        displayObj: initialState.displayObj,
      };
    default:
      return state;
  }
};
export default reducer;
